import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { setSEO } from "../utils/seo";

import MultiStepFormModal from "../components/MultiStepForm";


export default function ApplyPage() {
  useEffect(() => {
  setSEO({
    title: "Apply for Car Financing in Canada | YesAuto",
    description:
      "Apply for car financing with YesAuto. Complete your full auto loan application securely. All credit types accepted.",
  });
}, []);

  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-[#0a2545] overflow-hidden">

      {/* ✅ SEO + Quality Score Content (Behind Modal) */}
      <div className="text-center max-w-3xl mx-auto pt-24 px-4">
        <h1 className="text-3xl md:text-4xl font-bold text-white">
          Apply for Car Financing in Canada
        </h1>

        <p className="mt-4 text-gray-300 text-base md:text-lg">
          Complete this short application to check your eligibility.
          Fast approvals. No obligation.
        </p>

        <p className="mt-2 text-sm text-teal-300 font-medium">
          Trusted by 1500+ Canadians
        </p>
      </div>

      {/* ✅ Modal Form (Unchanged, Forced Open) */}
      <MultiStepFormModal
        isOpen={true}
        onClose={() => navigate("/")}
      />
    </div>
  );
}
